module services {
    export module master {
        export class paymentMethodService implements interfaces.master.IPaymentMethodService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }
                
            getDropdownList(ownerEntityId: number, isLetterOfCredit?: boolean): ng.resource.IResourceClass <interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "PaymentMethod/GetDropdownList", {
                    ownerEntityId: ownerEntityId,
                    isLetterOfCredit: isLetterOfCredit
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("paymentMethodService", services.master.paymentMethodService);
}